export default __webpack_public_path__ + "static/media/FinanceRealCase-sc.ac1dface.jpg";